<template>
  <section class="innerpages animate__animated animate__slideInRight">
    <div class="container ">
      <div class="row">
        <div class="col-md-12 listPage">
          <h1>{{activeSubStatusItem.label}}</h1>
          <div class="card ">
            <b-table
              :items="nonZeroData"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              sort-icon-right
              responsive="sm"
              show-empty
              @row-clicked="openList"
              tbody-tr-class="dataDivider"
              >
              <template v-slot:empty="scope">
                <h5 class="noData">No Data</h5>
              </template>
              <template v-slot:cell(count)="data">
                <i style="font-style:normal">{{ data.value }} 
                  <span class="icon-arrow">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve">
                        <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "></polygon>
                    </svg>
                  </span>
                </i>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
   data(){
    return {
      sortBy: 'count',
      sortDesc: false,
      fields: [
         { key: 'sub_status', sortable: true, 'class': 'headingClass'},
         { key: 'count', sortable: true }
      ]
    }
  },
  methods: {
    openList(item){
      let url="";
      url = `/leads/for/${this.activeSubStatusItem.itemType}/${this.activeSubStatusItem.itemId}/status/${this.activeSubStatusItem.statudId}/sub_status/${item.sub_status_id}/from/${this.fromDate}/upto/${this.toDate}`
      this.$router.push(url);
    }
  },
  computed: {
    activeSubStatusItem(){
      return this.$store.getters.activeSubStatusItem;
    },
    nonZeroData(){
      return (this.activeSubStatusItem.data || []).filter(a => (a.count > 0))
    },
    defaultDates(){
      return this.$store.getters.defaultDates;
    },
    fromDate(){
      return this.defaultDates.from;
    },
    toDate(){
      return this.defaultDates.upto;
    }
  }
}
</script>